import React, { memo, useMemo, useContext, useState } from 'react';
import { Segment } from 'tea-component';
import Loading from '@gp/components/Loading';
import NoData from "@gp/components/NoData";
import GeneralLegend from '@gp/components/GeneralLegendNew';
// @ts-ignore
import { BarEchart } from '@gp/components/CustomEchart';
import { getEChartOpt, tootipFormatter } from './utils/common';
import { context as Context } from '@gp/components/Context';
import {
  AF_LEGENDS_MAP,
} from '@gp/constants/budgetActualOrForecastCompletionEChart';
import { ECHART_COLOR } from '@gp/constants/echarts';
import { getFixedFieldColor } from '@gp/pages/StudioDashboard/StudioOverall/Tabs/People/Details/utils/common';
import './index.scss';

interface BarEchartConProps {
  [keyName: string]: any;
}

function BarEchartCon(props: BarEchartConProps) {
  const {} = props;

  const [legendSelected, setLegendSelected] = useState<{[keyName: string]: boolean} | null>(null);

  const {
    loading,
    dataList: data,
    filter,
    onChange,
  }: HeadcountsContextTypes = useContext(Context) || {};

  const legendOpt = useMemo(() => {
    let res: IGeneralLegend[] = [];
    const currentMetrics = data?.metrics;
    if (!currentMetrics || !Array.isArray(currentMetrics)) return res;
    res = [...AF_LEGENDS_MAP];
    const initLegendSelected: {[keyName: string]: boolean} = {};
    for(let i = 0, l = currentMetrics?.length; i < l; i ++) {
      const t = currentMetrics?.[i];
      initLegendSelected[t] = true;
      res.push({
        key: t,
        text: t,
        dotColor: getFixedFieldColor(t) || ECHART_COLOR?.[3 + i],
        showIcon: false,
      });
    }
    setLegendSelected(initLegendSelected);

    return res;
  }, [data?.metrics]);

  const tempOptions = useMemo(() => {
    return getEChartOpt(
      data,
      filter?.type,
    );
  }, [data, filter?.type]);

  const options = useMemo(() => {
    const opt = tempOptions;
    if (!legendSelected) return opt;

    return {
      ...opt,
      legend: {
        ...opt.legend,
        selected: legendSelected,
      },
      tooltip: {
        ...opt?.tooltip,
        formatter: tootipFormatter,
      },
    };
  }, [tempOptions, legendSelected]);

  return (
    <section className="dbg-studio-overall-details-people-headcounts-bar-content">
      <Segment
        className="dbg-studio-overall-details-people-fun-pro-segment"
        value={filter?.type}
        options={[
          {text: 'Function', value: '1', disabled: loading && filter?.type !== '1'},
          {text: 'Projects', value: '2', disabled: loading && filter?.type !== '2'},
        ]}
        onChange={onChange}
      />
      {loading ? (<Loading loading style={{height: 384}} />) :
      (!data || !data?.dataList?.length)
        ? (<NoData height={384} constomStyle={{fontSize: 14}} />)
        : (
            <>
              <BarEchart
                options={options}
                // xAxisData={}
                fontSize={12}
                // tootipFormatter={tootipFormatter}
                style={{height: '350px', width: '100%', marginTop: 20}}
              />
              <GeneralLegend
                options={legendOpt}
                value={legendSelected}
                onChange={(v: {[keyName: string]: boolean}) => {
                  setLegendSelected(legendSelected ? {
                    ...legendSelected,
                    ...v,
                  } : v);
                }}
              />
            </>
          )
      }
    </section>
  )
}

BarEchartCon.defaultProps = {
}

export default memo(BarEchartCon);
